import styled from 'styled-components/macro';
import {useRef, useState} from "react";
import {useLayoutEffect} from "../utils/use_isomorphic_layout_effect";

import {useRelativeTime} from "../store";
import {useUsername} from "../store/hooks";
import {useBlock} from "../api/user";
import {useFeedback} from "../store/feedback";
import NavLink from "./nav_link";
import TextContent from "./text_content";
import CreateReply from "./create_reply";
import {TextButton} from "./button";
import {themecolors} from "../utils/themecolors";

const Subject = styled.div``;
const Details = styled.div``;
const Actions = styled.div``;
const Item = styled.div``;
const Ago = styled.span``;

export const Author = ({className, username}) => {
    const isCommunityMail = username.startsWith("c:");
    const url = isCommunityMail ? `/c/${username.split("c:")[1]}` : `/u/${username}`;
    const displayName = isCommunityMail ? `/c/${username.split("c:")[1]}` : `${username}`;
    return (
        <span className={className}>
            <NavLink style={{fontWeight: username === "Scored" ? 500 : 400, color: username === 'Scored' ? '#d80000' : 'inherit'}} href={`${url}`} react_route>{displayName}</NavLink>
        </span>
    )
};

const Message = styled(({className, message, showSubject, hideActions, scrollIntoView, markRead, markUnread}) => {
    const ago = useRelativeTime(message?.created, true);
    const username = useUsername();
    const sent = message.author === username;
    const {feedbackCh} = useFeedback();
    const block = useBlock(feedbackCh);
    const handleBlock = async () => {
        try {
            await block(sent ? message.recipient : message.author);
        } catch {
        }
    };
    const [reply, setReply] = useState(false);
    const handleReply = () => {
        setReply(!reply);
    };
    const ref = useRef();
    useLayoutEffect(() => {
        if (scrollIntoView && ref.current) {
            ref.current.scrollIntoView();
        }
    }, [scrollIntoView]);

    return (
        <div className={className} ref={ref}>
            {showSubject && <Subject>{message.subject}</Subject>}
            <Details>

                {sent ?
                    <>to <Author username={message.recipient} /></>
                    :
                    <><Author username={message.author} /></>
                }

                <Ago>
                    {` - ${ago} ago`}
                </Ago>
            </Details>
            {message.content && <TextContent content={message.content} />}
            {message.is_deleted && <div>Deleted</div>}
            {!hideActions && (<Actions>
                <Item>
                    <NavLink href={`/message/${message.conversation_id}`} react_route>
                        link
                    </NavLink>
                </Item>
                <Item onClick={handleBlock}>
                    block user
                </Item>
                {markRead && <TextButton onClick={markRead}>mark read</TextButton>}
                {markUnread && <TextButton onClick={markUnread}>mark unread</TextButton>}
                {message.type !== 5 && message.type !== 2 && <Item onClick={handleReply}>reply</Item>}
            </Actions>)}
            {reply && <CreateReply message={message} setReply={setReply} onClose={handleReply}/>}
        </div>
    );
})`
  padding: 16px;
  ${Subject} {
    font-weight: 600;
    font-size: 15px;
  }
  ${Details} {
    font-size: 13px;
    margin-bottom: 8px;
  }
  p {
    margin: 0;
  }
  ${Ago} {
    color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_medium_impact_text : themecolors.light_medium_impact_text};
  }
  ${Actions} {
    display: flex;
    flex-wrap: wrap;
    margin-top: 8px;
    color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_medium_impact_text : themecolors.light_medium_impact_text};
  }
  ${Item}, ${TextButton} {
    margin-right: 12px;
    font-size: 12px;
    cursor: pointer;
  }
  ${Details} a {
    color: ${({theme}) => theme.color.name === 'dark' ? themecolors.pure_white : theme.placeholder_link_2};
    font-weight: ${({theme}) => theme.color.name === 'dark' ? '500' : '400'};
  }
`;

export default Message;
